import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Push notification registration moved to <PushRegistrar /> inside <AuthProvider>
// (see /app/frontend/src/components/PushRegistrar.js + hooks/usePushRegistration.js).
// The legacy bootstrap path here ran the register-device POST before Clerk had
// a session, so the request landed on the backend with no Authorization header
// and was rejected with 401 — the device token never reached `device_tokens`.
// The hook now waits for `isLoaded && isSignedIn`, then attaches the Clerk
// Bearer token to the POST.

// Conditionally apply StrictMode only in development
// In production, StrictMode's double mount/unmount can interfere with Clerk's session initialization
const Wrapper = process.env.NODE_ENV === 'development' ? React.StrictMode : React.Fragment;

// Use hydrateRoot when react-snap prerendered HTML exists, otherwise createRoot
// Check for actual element children (not whitespace/comments) to avoid hydration loops
const rootElement = document.getElementById("root");
const hasPrerenderedContent = rootElement.children.length > 0;

if (hasPrerenderedContent && navigator.userAgent !== 'ReactSnap') {
  ReactDOM.hydrateRoot(
    rootElement,
    <Wrapper>
      <App />
    </Wrapper>
  );
} else {
  ReactDOM.createRoot(rootElement).render(
    <Wrapper>
      <App />
    </Wrapper>
  );
}
